import getLogger from '@ignitesales/logger-es';
import ignite from '../ignite.mjs';
import { actionCompleted } from './question-action-creators.mjs';

const logger = getLogger({ module: 'contactme-action-creators' });

const ContactMeActions = {
  CONTACTME_LEAD_UPDATE_STARTED: 'CONTACTME_LEAD_UPDATE_STARTED',
  CONTACTME_LEAD_UPDATED: 'CONTACTME_LEAD_UPDATED',
  APPOINTMENT_TIMESLOT_SELECTED: 'APPOINTMENT_TIMESLOT_SELECTED',
  APPOINTMENT_TIMESLOTS_UPDATE_STARTED: 'APPOINTMENT_TIMESLOTS_UPDATE_STARTED',
  APPOINTMENT_TIMESLOTS_UPDATED: 'APPOINTMENT_TIMESLOTS_UPDATED',
  APPOINTMENT_LOCATION_SEARCH_UPDATED: 'APPOINTMENT_LOCATION_SEARCH_UPDATED',
  APPOINTMENT_LOCATION_SELECTED: 'APPOINTMENT_LOCATION_SELECTED',
  APPOINTMENT_LOCATIONS_UPDATE_STARTED: 'APPOINTMENT_LOCATIONS_UPDATE_STARTED',
  APPOINTMENT_LOCATIONS_UPDATED: 'APPOINTMENT_LOCATIONS_UPDATED',
  APPOINTMENT_BOOKING_STARTED: 'APPOINTMENT_BOOKING_STARTED',
  APPOINTMENT_BOOKING_COMPLETE: 'APPOINTMENT_BOOKING_COMPLETE'
};

const appointmentBookingComplete = (appointment) => {
  return {
    type: ContactMeActions.APPOINTMENT_BOOKING_COMPLETE,
    appointment
  };
};

const appointmentLocationSearchUpdated = (locationSearchForm) => {
  return {
    type: ContactMeActions.APPOINTMENT_LOCATION_SEARCH_UPDATED,
    locationSearchForm
  };
};

const appointmentLocationSelected = (location) => {
  return {
    type: ContactMeActions.APPOINTMENT_LOCATION_SELECTED,
    location
  };
};

const appointmentTimeSlotSelected = (time) => {
  return {
    type: ContactMeActions.APPOINTMENT_TIMESLOT_SELECTED,
    time
  };
};

const bookAppointment = (appointment, cb) => {
  return async (dispatch) => {
    try {
      dispatch( startProcessing(ContactMeActions.APPOINTMENT_BOOKING_STARTED) );
      const result = await ignite.appointmentService.bookAppointment(appointment);
      cb(result.status);
      if (result.status) {
        await ignite.answerService.saveAnswer({
          appkey: 'appointmentId',
          value: result.id,
          timestamp: new Date()
        });
        await ignite.answerService.saveAnswer({
          appkey: 'appointmentTime',
          value: appointment.time,
          timestamp: new Date()
        });
        dispatch( appointmentBookingComplete(result) );
        dispatch( actionCompleted({ actionName: 'makeAppointmentClicked' }) );
      }
    } catch (ex) {
      logger.error('An error occured while booking appointment', ex);
      cb(false);
    }
  };
};

const sendContactFieldsToAnswerService = (contactLead, fieldsForAnswerService = []) => {
  if (fieldsForAnswerService.length > 0) {
    Object.keys(contactLead).forEach(async field => {
      if (fieldsForAnswerService.includes(field)) {
        await ignite.answerService.saveAnswer({
          appkey: field,
          value: contactLead[field],
          timestamp: new Date()
        });
      }
    });
  }
};

const contactLeadUpdate = ({ contactLead, fieldsForAnswerService } ) => {
  return async (dispatch) => {
    try {
      dispatch( startProcessing(ContactMeActions.CONTACTME_LEAD_UPDATE_STARTED) );
      sendContactFieldsToAnswerService(contactLead, fieldsForAnswerService);
      await ignite.contactService.submitContact(contactLead);
      ignite.contactService.sendLead();
      dispatch( actionCompleted({ actionName: 'contactMeClicked' }) );
      dispatch( contactLeadUpdateComplete(contactLead) );
    } catch (ex) {
      logger.error('Error while saving lead', ex);
    }
  };
};

const contactLeadUpdateComplete = (contactLead) => {
  return {
    type: ContactMeActions.CONTACTME_LEAD_UPDATED,
    contactLead
  };
};

const getAvailableTimeSlots = (request) => {
  return async (dispatch) => {
    try {
      dispatch( startProcessing(ContactMeActions.APPOINTMENT_TIMESLOTS_UPDATE_STARTED) );
      const results = await ignite.appointmentService.getTimeSlots(request);
      const timeSlots = results.map(timeSlot => {
        timeSlot.start = new Date(timeSlot.time);
        timeSlot.end = new Date(timeSlot.time);
        timeSlot.end.setHours(timeSlot.start.getHours(), timeSlot.start.getMinutes() + parseInt(timeSlot.length));
        return timeSlot;
      });
      dispatch( setAvailableTimeSlots(timeSlots) );
    } catch (ex) {
      logger.error('An error while loading time slots', ex);
    }
  };
};

const getLocations = ({ lat, lng }) => {
  return async (dispatch, getState) => {
    try {
      dispatch( startProcessing(ContactMeActions.APPOINTMENT_LOCATIONS_UPDATE_STARTED) );
      const searchForLocationMatch = getState().contactMe.searchForLocationMatch;
      const locations = await ignite.appointmentService.getLocations({ lat, lng, searchForLocationMatch });
      dispatch( setLocations(locations || []) );
    } catch (ex) {
      logger.error('An error while loading locations', ex);
    }
  };
};

const setAvailableTimeSlots = (availableTimeSlots) => {
  return {
    type: ContactMeActions.APPOINTMENT_TIMESLOTS_UPDATED,
    availableTimeSlots
  };
};

const setLocations = (availableLocations) => {
  return {
    type: ContactMeActions.APPOINTMENT_LOCATIONS_UPDATED,
    availableLocations
  };
};

const startProcessing = (type) => {
  return {
    type
  };
};


export {
  appointmentBookingComplete,
  appointmentLocationSelected,
  appointmentLocationSearchUpdated,
  appointmentTimeSlotSelected,
  bookAppointment,
  contactLeadUpdate,
  contactLeadUpdateComplete,
  ContactMeActions,
  getAvailableTimeSlots,
  getLocations,
  setAvailableTimeSlots,
  setLocations
};
